export const renumerationModalInitValue = {
  data: {
    date: '',
    file: undefined,
    comments: '',
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    lastOperationDate: '',
    scriptureView: true,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    onChangeNotaryName(): void {},
    onChangeNotaryProtocol(): void {},
    onChangeNotaryCity(): void {},
    handleSaveRenumeration(): void {},
  },
};
